export default {
  template: '#purchase_product_color',
  props: ["color", "product"],
  data: function() {
    return {
      sizes: {
        'S': 0,
        'M': 0,
        'L': 0,
        'XL': 0,
        'TWO_XL': 0,
        'THREE_XL': 0,
        'FOUR_XL': 0,
        'FIVE_XL': 0
      }
    };
  },
  events: {
    'pricing-recalculated': function() {
      this.watchSizeCounts(true);
    }
  },
  watch: {
    sizes: {
      deep: true,
      handler: 'watchSizeCounts'
    }
  },
  methods: {
    sizeExists: function(size) {
      var product = this.product,
        sizes = product.sizes.split(',');

      return _.indexOf(sizes, size) > -1;
    },
    watchSizeCounts: function(eventCall) {
      var price = this.$parent.$parent.$parent.groupProductsForSale(this.sizes, this.product, this.color, eventCall || false);
      this.$parent.$parent.price = price || 0.00;
    },
    hasUpSizes: function() {
      var sizes = this.sizes;
      return (sizes.XL > 0 || sizes.TWO_XL > 0 || sizes.THREE_XL > 0 || sizes.FOUR_XL > 0 || sizes.FIVE_XL > 0);
    },
    getUpChargePriceBySize: function(size) {
      var upChargeCost = JSON.parse(this.product.upcharges),
        price = parseFloat(upChargeCost[size]);
      if (price > 0)
        return '+ $' + parseFloat(upChargeCost[size]).toFixed(2);
      else
        return "";
    },
    getUpChargePrices: function() {
      var calculatedPrices = 0.00;

      if (this.countTotal > 0) {
        calculatedPrices = parseFloat(this.$parent.$parent.price);
        if (this.hasUpSizes()) {
          var upChargeCost = JSON.parse(this.product.upcharges),
            sizes = this.sizes;
          if (sizes.XL > 0) {
            calculatedPrices += parseFloat(parseInt(sizes.XL, 10) * parseFloat(upChargeCost['XL']))
          }

          if (sizes.TWO_XL > 0) {
            calculatedPrices += parseFloat(parseInt(sizes.TWO_XL, 10) * parseFloat(upChargeCost['2XL']))
          }

          if (sizes.THREE_XL > 0) {
            calculatedPrices += parseFloat(parseInt(sizes.THREE_XL, 10) * parseFloat(upChargeCost['3XL']))
          }

          if (sizes.FOUR_XL > 0) {
            calculatedPrices += parseFloat(parseInt(sizes.FOUR_XL, 10) * parseFloat(upChargeCost['4XL']))
          }

          if (sizes.FIVE_XL > 0) {
            calculatedPrices += parseFloat(parseInt(sizes.FIVE_XL, 10) * parseFloat(upChargeCost['5XL']))
          }
        }
      } else
        calculatedPrices = 0.00;

      return calculatedPrices;
    }
  },
  computed: {
    countTotal: function() {
      var sizes = this.sizes;
      return (parseInt(sizes.S) || 0) + (parseInt(sizes.M) || 0) + (parseInt(sizes.L) || 0) +
        (parseInt(sizes.XL) || 0) + (parseInt(sizes.TWO_XL) || 0) + (parseInt(sizes.THREE_XL) || 0) +
        (parseInt(sizes.FOUR_XL) || 0) + (parseInt(sizes.FIVE_XL) || 0);
    },
    getPrice: function() {
      return parseFloat(this.$parent.$parent.price);
    }
  }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/launch_tab/manualOrderProductColors.js